import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button, Input, Modal, ModalBody, ModalFooter, ModalHeader, Table } from "reactstrap";
import { useUser } from './Context/UserContext';
import profileImg from "../assets/logo.png";
import ViewAllVendors from "./ViewAllVendors";
/*import "../styles/ViewAllInvoiceDeptHead.css";*/
import "../styles/ViewAllInvoiceCFO.css";
import VendorInfoTabs from "./VendorInfoTabs";
import DashboardLayout from "./DashboardLayout";
import Select from "react-select";
const ViewAllInvoicesCFO = () => {
    const [invoices, setInvoices] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [sidebarOpen, setSidebarOpen] = useState(true);
    const [showCard, setShowCard] = useState(false);
    const [selectedInvoice, setSelectedInvoice] = useState(null); // or invoice
    const [showModal, setShowModal] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [activeTab, setActiveTab] = useState("history"); // or "history"
    const [comment, setComment] = useState("");
    const [sortBy, setSortBy] = useState("");
    const [sortOrder, setSortOrder] = useState("asc");
    const [invoiceInfo, setInvoiceInfo] = useState(null);
    const [info, setinfo] = useState(null);
    const [VendorInfo, setVendorInfo] = useState(null);
    const [selectedVendor, setSelectedVendor] = useState(null);
    const [subTab, setSubTab] = useState("details");
    //const [isEditing, setIsEditing] = useState(false);
    const [approvalStatusError, setApprovalStatusError] = useState("");
    const [commentError, setCommentError] = useState("");
    const [rejectionSendToError, setRejectionSendToError] = useState("");
    const [supplierTypeError, setSupplierTypeError] = useState("");
    const [departmentHeadError, setDepartmentHeadError] = useState("");
    const [verifierError, setVerifierError] = useState("");
    const [emailApprovalError, setemailApprovalError] = useState("");
    const [poError, setpoError] = useState("");
    const [prError, setprError] = useState("");
    const [quotationError, setquotationError] = useState("");
    const [selectedStatus, setSelectedStatus] = useState(3);
    const { user: loggedInUser } = useUser();
    const [users, setUsers] = useState([]);
    const { user } = useUser();
    const [approverId, setApproverId] = useState(null);
    const [loading, setLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [supplierTypes, setSupplierTypes] = useState([]);
    const [departmentHeads, setDepartmentHeads] = useState([]);
    const [verifiers, setVerifiers] = useState([]);
    const [files, setFiles] = useState({});
    const [vendorFiles, setVendorFiles] = useState({});
    const [poFiles, setPoFiles] = useState({});
    const [formData, setFormData] = useState({});
    const [showPreview, setShowPreview] = useState(false);
    const [previewUrl, setPreviewUrl] = useState("");
    const [previewTitle, setPreviewTitle] = useState("");
    const [approvalHistory, setApprovalHistory] = useState([]);
    const [backendStatus, setBackendStatus] = useState(null);
    const [financeApproval, setFinanceApproval] = useState(null);
    const FINAL_STATUSES = [18, 19, 20, 21, 22, 23];
    const isFinalStatus = FINAL_STATUSES.includes(backendStatus);
    const isApproved = backendStatus === 23;
    const isRejected = [18, 19, 20, 21, 22].includes(backendStatus);
    const BASE_URL = "/";
    const [lobOptions, setLobOptions] = useState([]);
    const [projectNameOptions, setProjectNameOptions] = useState([]);
    const [taxGroupOptions, setTaxGroupOptions] = useState([]);
    const [loadingDropdowns, setLoadingDropdowns] = useState(false);
    const [dropdownError, setDropdownError] = useState("");
    const isCFOView = true;
    const [selectedIds, setSelectedIds] = useState([]);
    const isReadyToMoveSage = Number(selectedStatus) === 4;
    const [selectAll, setSelectAll] = useState(false);
    const [showModalNew, setShowModalNew] = useState(false);
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [errors, setErrors] = useState({});
    const [sageSending, setSageSending] = useState(false);
    //const isApproved = String(selectedInvoice?.approvalStatus) === "1";
    //const isRejected = String(selectedInvoice?.approvalStatus) === "2";
    const [approvedInvoices, setApprovedInvoices] = useState([]);
    const [rejectedInvoices, setRejectedInvoices] = useState([]);
    <ViewAllVendors
        activeTab={activeTab}
        subTab={subTab}
        setSubTab={setSubTab}
        isEditing={isEditing}
        selectedVendor={selectedInvoice} // can rename internally if needed
        //handleInputChange={handleInputChange}
        setIsEditing={setIsEditing}
    />
    useEffect(() => {
        const id = loggedInUser?.empId || sessionStorage.getItem("userId");
        if (id) {
            setApproverId(id); // ensure number
            console.log("✅ Approver ID set:", id);
        } else {
            console.log("⏳ Waiting for user info to load...");
        }
    }, [loggedInUser]);
    const handleReviewClick = async (selected) => {
        console.log("REVIEW CLICKED ROW:", selected);
        if (!selected) return;

        console.log("Opening Invoice:", selected);

        // Reset previous data
        setFinanceApproval(null);
        setBackendStatus(null);
        setGoodsInitialized(false);
        setSelectedInvoice(null);
        setInvoiceInfo(null);
        setVendorInfo(null);
        setSelectedVendor(null);
        setFiles({});
        setPoFiles({});
        setApprovalHistory([]);
        setHistoryData([]);
        setComment("");
        setApprovalStatusError("");
        setCommentError("");
        setRejectionSendToError("");

        setSelectedInvoice({
            ...selected,
            approvalStatus: "",
            rejectionSendTo: "",
            comment: "",
            goodsList: []
        });

        setActiveTab("infoInvoice");
        setShowModal(true);

        // ✅ Detect credit-card invoice from the LIST row, not invoiceData
        const rawName = selected?.nameOfCompany || "";
        const isCreditCardInvoice = rawName.toLowerCase().includes("credit card");

        // Strip ALL "Credit Card - " prefixes (handles the doubled prefix bug)
        const cardNumber = rawName.replace(/Credit Card\s*-\s*/gi, "").trim();

        try {
            const invoiceRes = await axios.get(`/api/invoices/info/${selected.id}`);
            const invoiceData = invoiceRes.data;
            console.log("Invoice Info:", invoiceData);
            setInvoiceInfo(invoiceData);

            const userId = invoiceData?.userid;
            if (!userId) {
                setSelectedVendor({
                    nameOfCompany: isCreditCardInvoice
                        ? `Credit Card - ${cardNumber}`
                        : selected.nameOfCompany || "N/A",
                    taxGroups: null
                });
                setVendorInfo(null);
                setFiles({});
                return;
            }

            const vendorRes = await axios.get(`/api/vendordetails/vendor-by-userid/${userId}`);
            const vendorData = {
                ...vendorRes.data,
                vendorId: vendorRes.data?.vendorId ?? vendorRes.data?.VendorId ?? vendorRes.data?.id,
                nameOfCompany: isCreditCardInvoice
                    ? `Credit Card - ${cardNumber}`
                    : vendorRes.data?.nameOfCompany
            };
            setVendorInfo(vendorData);
            setSelectedVendor(vendorData);

            if (vendorData.vendorId) {
                const filesRes = await axios.get(`/api/vendor/files/vendor/${vendorData.vendorId}`);
                const filesMapped = {};
                (filesRes.data || []).forEach((file) => {
                    const key = file.docName?.toUpperCase();
                    if (key) {
                        filesMapped[key] = {
                            fileId: file.fileId,
                            fileName: file.fileName,
                            fileExtension: file.fileExtension,
                            filePath: `/api/vendor/files/${file.fileId}?mode=view`
                        };
                    }
                });
                setFiles(filesMapped);
            }
            
        } catch (error) {
            console.error("❌ Error loading invoice/vendor:", error);
            setSelectedVendor(null);
            setVendorInfo(null);
            setFiles({});
            alert("Unable to load vendor details.");
        }
    };

    useEffect(() => {
        fetchDropdownData();
    }, []);
    const fetchDropdownData = async () => {
        try {
            setLoadingDropdowns(true);
            setDropdownError("");
            const [lobRes, projRes, taxGroupRes] = await Promise.all([
                axios.get("/api/invoices/lob"),
                axios.get("/api/invoices/projectnames"),
                axios.get("/api/invoices/taxgroups")
            ]);
            setLobOptions(lobRes.data || []);
            setProjectNameOptions(projRes.data || []);
            setTaxGroupOptions(taxGroupRes.data || []);
            console.log("LOB:", lobRes.data);
            console.log("Projects:", projRes.data);
            console.log("TaxGroups:", taxGroupRes.data);
        } catch (error) {
            console.error("Error fetching dropdown data", error);
            setDropdownError("Failed to load dropdown data.");
        } finally {
            setLoadingDropdowns(false);
        }
    };
    const [goodsInitialized, setGoodsInitialized] = useState(false);
    // Initialize goods once
    useEffect(() => {
        if (
            !goodsInitialized &&
            (!selectedInvoice?.goodsList || selectedInvoice.goodsList.length === 0) &&
            invoiceInfo?.grnItems?.length > 0 &&
            taxGroupOptions?.length > 0
        ) {
            const initializedGoods = invoiceInfo.grnItems.map((item, idx) => {
                const matchingGroup =
                    taxGroupOptions.find(
                        (group) =>
                            group.taxGroup?.toUpperCase() ===
                            item.taxGroupCode?.toUpperCase()
                    ) ||
                    taxGroupOptions.find(
                        (group) =>
                            group.taxGroup?.toUpperCase() ===
                            selectedVendor?.taxGroups?.toUpperCase()
                    );
                const authorities = matchingGroup?.authorities || [];
                const getRate = (type) => {
                    const authority = authorities.find((auth) =>
                        auth.taxAuthority?.toUpperCase().includes(type.toUpperCase())
                    );
                    return authority?.taxRates?.[0] || 0;
                };
                return {
                    id: item.id,
                    description: item.description || "",
                    invoiceValue: item.invoiceValue || 0,
                    cgst: getRate("CGST"),
                    sgst: getRate("SGST"),
                    igst: getRate("IGST"),
                    tds: getRate("TDS"),
                    totalValue: item.totalValue || 0,
                    lob: item.lob || "",
                    projectName: item.projectName || "",
                    mspe: item.mspe,
                    taxGroupCode: matchingGroup?.taxGroup || item.taxGroupCode || "",
                };
            });
            setSelectedInvoice((prev) => ({
                ...prev,
                goodsList: initializedGoods
            }));
            setGoodsInitialized(true);
        }
    }, [invoiceInfo, taxGroupOptions, selectedVendor, goodsInitialized, selectedInvoice]);
    // Handle changes in goods row
    const handleGoodsChange = (index, key, value) => {
        setSelectedInvoice((prev) => {
            const updatedGoodsList = [...(prev.goodsList || [])];
            const item = { ...updatedGoodsList[index] };
            if (key === "taxGroupCode") {
                item.taxGroupCode = value;
                const selectedGroup = taxGroupOptions.find(
                    (g) =>
                        g.taxGroup?.toUpperCase() === value?.toUpperCase()
                );
                const authorities = selectedGroup?.authorities || [];
                const getFirstRate = (type) => {
                    const authority = authorities.find((auth) =>
                        auth.taxAuthority?.toUpperCase().includes(type.toUpperCase())
                    );
                    // 🚀 DO NOT FILTER ZERO
                    return authority?.taxRates?.[0] || 0;
                };
                item.cgst = getFirstRate("CGST");
                item.sgst = getFirstRate("SGST");
                item.igst = getFirstRate("IGST");
                item.tds = getFirstRate("TDS");
            } else {
                item[key] = value;
            }
            // 🚀 NO TOTAL CALCULATION HERE
            // totalValue remains what backend sent
            updatedGoodsList[index] = item;
            return { ...prev, goodsList: updatedGoodsList };
        });
    };
   
    useEffect(() => {
        if (!selectedVendor?.vendorId) return;
        axios
            .get(`/api/vendor/files/vendor/${selectedVendor.vendorId}`)
            .then((res) => {
                const filesMapped = {};
                res.data.forEach((file) => {
                    const key = file.docName.toUpperCase(); // PAN, GST, MSME, CHEQUE
                    filesMapped[key] = {
                        fileId: file.fileId,
                        fileName: file.fileName,
                        fileExtension: file.fileExtension,
                        filePath: `/api/vendor/files/${file.fileId}?mode=view`, // preview link
                    };
                });
                setFiles(filesMapped);
            })
            .catch((err) => {
                console.error("Error fetching vendor files:", err);
                setFiles({});
            });
    }, [selectedVendor]);
    const handleFileChange = (e) => {
        const { name, files: selectedFiles } = e.target;
        if (selectedFiles && selectedFiles.length > 0) {
            setFiles((prev) => ({
                ...prev,
                [name]: selectedFiles[0]
            }));
        }
    };
    const statusMapping = {
        All: 0,
        Pending: 3,
        Rejected: 2,
        Approved: 1,
        ReadytoMoveSAGE: 4
    };
    const mapBackendStatusToUI = (status) => {
        if (status === 23) return "1"; // Approved
        if ([18, 19, 20, 21, 22].includes(status))
            return "2"; // Rejected
        return "3"; // Pending
    };
    const mapInvoiceSendTo = (status) => {
        if (status === 18) return "Finance Team";
        if (status === 19) return "DEPT HEAD";
        if (status === 20) return "PO";
        if (status === 21) return "Security";
        if (status === 22) return "Vendor";
        return "";
    };
    useEffect(() => {
        const fetchInvoices = async () => {
            setLoading(true);
            try {
                const res = await axios.get(
                    "/api/invoices/cfo-list",
                    {
                        params: {
                            statusId: selectedStatus || 3,
                            search: searchTerm || ""
                        }
                    }
                );
                console.log("CFO Invoices:", res.data);
                setInvoices(res.data || []);
            } catch (err) {
                console.error("Error fetching finance invoices:", err);
                setInvoices([]);
            } finally {
                setLoading(false);
            }
        };
        fetchInvoices();
    }, [selectedStatus, searchTerm]);
    const handleInputChange = (e, field) => {
        setSelectedVendor({ ...selectedVendor, [field]: e.target.value });
    };
    const handleSort = (column) => {
        const sortedInvoices = [...invoices].sort((a, b) => {
            let valueA, valueB;
            if (column === "approvalStatus") {
                valueA = a.approvalStatus?.toLowerCase() || "";
                valueB = b.approvalStatus?.toLowerCase() || "";
            }
            if (sortOrder === "asc") {
                return valueA > valueB ? 1 : -1;
            } else {
                return valueA < valueB ? 1 : -1;
            }
        });
        setInvoices(sortedInvoices);
        setSortOrder(sortOrder === "asc" ? "desc" : "asc");
        setSortBy(column);
    };
    const invoicesPerPage = 10;
    const [historyData, setHistoryData] = useState([]);
    useEffect(() => {
        if (!selectedInvoice?.id) return;
        console.log("Invoice ID being sent:", selectedInvoice.id);
        axios
            .get(`/api/invoices/approval-history/${selectedInvoice.id}`)
            .then((res) => {
                console.log("APPROVAL HISTORY:", res.data);
                setHistoryData(res.data);
            })
            .catch((err) => {
                console.error("Error fetching approval history:", err);
                setHistoryData([]);
            });
    }, [activeTab, selectedInvoice]);
    useEffect(() => {
        if (activeTab !== "infoInvoice") return;
        const invoiceId = selectedInvoice?.id || selectedInvoice?.ID;
        if (!invoiceId) return;
        axios
            .get(`/api/invoices/info/${invoiceId}`)
            .then((res) => {
                console.log("Invoice Info:", res.data);
                setInvoiceInfo(res.data); // <-- use res.data directly
            })
            .catch((err) => {
                console.error("Error fetching invoice info:", err);
            });
    }, [activeTab, selectedInvoice]);
    // Pagination
    const totalPages = Math.ceil(invoices.length / invoicesPerPage);
    const startIndex = (currentPage - 1) * invoicesPerPage;
    const currentInvoices = invoices.slice(startIndex, startIndex + invoicesPerPage);
    const handlePageChange = (action) => {
        if (action === "first") setCurrentPage(1);
        else if (action === "prev" && currentPage > 1) setCurrentPage(prev => prev - 1);
        else if (action === "next" && currentPage < totalPages) setCurrentPage(prev => prev + 1);
        else if (action === "last") setCurrentPage(totalPages);
    };
    useEffect(() => {
        axios
            .get("/api/supplier/supplier-types")
            .then((res) => {
                setSupplierTypes(res.data);
            })
            .catch((err) => {
                console.error("Error fetching supplier types:", err);
                setSupplierTypes([]);
            });
    }, []);
    useEffect(() => {
        if (!selectedInvoice?.id) return;
        console.log("📡 Calling API with recordId:", selectedInvoice.id);
        axios
            .get(`/api/supplier/invoice-approval-data/${selectedInvoice.id}`)
            /*.get(`/api/supplier/invoice-approval-data/39`)*/
            .then((res) => {
                const data = res.data;
                console.log("✅ API ResponseDEPT,VERIFIER:", data);
                // 1️⃣ First set dropdown lists
                setDepartmentHeads(data.departmentHeads || []);
                setVerifiers(data.verifiers || []);
                // 2️⃣ Then update selectedInvoice AFTER options exist
                setTimeout(() => {
                    setSelectedInvoice((prev) => ({
                        ...prev,
                        supplierType: data.supplierType ? String(data.supplierType) : "",
                        departmentHead: data.departmentHeadId || "",
                        verifier: data.verifierId || ""
                    }));
                }, 0);
            })
            .catch((err) => {
                console.error("❌ Error loading approval data:", err);
            });
    }, [selectedInvoice?.id]);
    const styles = {
        overlay: {
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.6)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000
        },
        modal: {
            width: "360px",
            background: "#fff",
            borderRadius: "10px",
            boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
            overflow: "hidden",
            animation: "fadeIn 0.2s ease-in-out"
        },
        header: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "12px 16px",
            borderBottom: "1px solid #eee",
            fontWeight: "600"
        },
        closeIcon: {
            fontSize: "20px",
            cursor: "pointer",
            color: "#888"
        },
        body: {
            padding: "16px"
        },
        inputGroup: {
            marginBottom: "14px"
        },
        input: {
            width: "100%",
            padding: "10px",
            borderRadius: "6px",
            border: "1px solid #ccc",
            fontSize: "14px",
            outline: "none"
        },
        error: {
            color: "red",
            fontSize: "12px",
            marginTop: "4px"
        },
        footer: {
            display: "flex",
            justifyContent: "flex-end",
            gap: "10px",
            padding: "12px 16px",
            borderTop: "1px solid #eee"
        },
        cancelBtn: {
            padding: "8px 14px",
            background: "#ddd",
            border: "none",
            borderRadius: "6px",
            cursor: "pointer"
        },
        submitBtn: {
            padding: "8px 14px",
            background: "#1f4e78",
            color: "#fff",
            border: "none",
            borderRadius: "6px",
            cursor: "pointer"
        }
    };
    const handleSaveStatus = async () => {
        let isValid = true;
        // ✅ Approval Status validation
        if (
            String(selectedInvoice?.approvalStatus) !== "1" &&
            String(selectedInvoice?.approvalStatus) !== "2"
        ) {
            setApprovalStatusError("Approval status is required");
            isValid = false;
        }
        // ✅ Comments validation
        if (!selectedInvoice?.comment || selectedInvoice.comment.trim() === "") {
            setCommentError("Comments are required");
            isValid = false;
        }
        // ✅ Rejection Send To validation
        if (
            selectedInvoice?.approvalStatus === "2" &&
            !selectedInvoice?.rejectionSendTo
        ) {
            setRejectionSendToError("Please select where to send");
            isValid = false;
        }
        if (!isValid) return;
        try {
            const payload = {
                InvoiceId: selectedInvoice.id,
                InvoiceNo: selectedInvoice.invoiceNo,
                ApprovalStatus: Number(selectedInvoice.approvalStatus),
                CfoID: loggedInUser.empId,   // ✅ Correct field name
                Comments: selectedInvoice.comment,
                RejectionSendTo:
                    selectedInvoice.approvalStatus === "2"
                        ? Number(selectedInvoice.rejectionSendTo)
                        : null
            };
            console.log("CFO PAYLOAD:", payload);
            const response = await axios.post(
                "/api/invoice/cfo-approval", // ✅ Correct URL
                payload
            );
            if (response.status === 200) {
                alert(response.data.message);
                setInvoices(prev =>
                    prev.filter(inv => inv.id !== selectedInvoice.id)
                );
                let updatedInvoice = { ...selectedInvoice };
                if (selectedInvoice.approvalStatus === "1") {
                    updatedInvoice.approvalStatus = "Invoice Final Approved by CFO";
                    updatedInvoice.backendStatus = 9;
                    setApprovedInvoices(prev => [...prev, updatedInvoice]);
                } else if (selectedInvoice.approvalStatus === "2") {
                    updatedInvoice.approvalStatus =
                        selectedInvoice.rejectionSendTo === "1"
                            ? "Invoice Rejected by CFO → Finance"
                            : selectedInvoice.rejectionSendTo === "2"
                                ? "Invoice Rejected by CFO → Dept Head"
                                : selectedInvoice.rejectionSendTo === "3"
                                    ? "Invoice Rejected by CFO → PO"
                                    : selectedInvoice.rejectionSendTo === "4"
                                        ? "Invoice Rejected by CFO → Security"
                                        : "Invoice Rejected by CFO → Vendor";
                    updatedInvoice.backendStatus = 6;
                    setRejectedInvoices(prev => [...prev, updatedInvoice]);
                }
                setShowModal(false);   // ✅ add this
                setIsEditing(false);  // ✅ add this
            }
        } catch (error) {
            console.error("Error saving CFO approval:", error);
            const errorMessage =
                error?.response?.data?.message ||
                error?.response?.data?.error ||
                error?.message ||
                "Something went wrong";
            alert(errorMessage);
        }
    };
    const mapSendToToDropdownValue = (sentBackTo) => {
        console.log("🔄 Mapping SentBackTo:", sentBackTo);
        if (sentBackTo === "Finance Team") return "1";
        if (sentBackTo === "Dept Head") return "2";
        if (sentBackTo === "PO") return "3";
        if (sentBackTo === "Security") return "4";
        if (sentBackTo === "Vendor") return "5";
        return "";
    };
    useEffect(() => {
        if (!showModal || !selectedInvoice?.id) return;
        axios.get(
            `/api/invoice/finance-invoice-full/${selectedInvoice.id}`
        )
            .then(res => {
                const goods = res.data.goodsList || [];
                console.log("✅ Setting Goods:", goods);
                setSelectedInvoice(prev => ({
                    ...prev,
                    goodsList: goods
                }));
            })
            .catch(err => console.error(err));
    }, [showModal]);   // 🔥 REMOVE selectedInvoice?.id
    useEffect(() => {
        if (!showModal || !selectedInvoice?.id || !approverId) return;
        console.log("📡 Loading CFO Invoice Full...");
        axios.get(
            `/api/invoice/cfo-invoice-full/${selectedInvoice.id}`,
            {
                params: { approverId }
            }
        )
            .then(res => {
                const data = res.data;
                console.log("🔥 CFO API RESPONSE:", data);
                // ✅ Set backend status for button control
                const statusId = data?.approval?.statusId || null;
                setBackendStatus(statusId);
                // ✅ Map approval status to UI dropdown
                const uiApprovalStatus = mapBackendStatusToUI(statusId);
                // ✅ Map rejection send to dropdown
                const uiSendTo = mapSendToToDropdownValue(
                    data?.approval?.sentBackTo
                );
                setSelectedInvoice(prev => ({
                    ...prev,
                    goodsList: data.goodsList || [],
                    approvalStatus: uiApprovalStatus,
                    rejectionSendTo: uiSendTo,
                    comment: data?.approval?.comments || ""
                }));
            })
            .catch(err => {
                console.error("❌ CFO Invoice Load Error:", err);
            });
    }, [showModal, selectedInvoice?.id, approverId]);
    const handleSubmit = async () => {

        let newErrors = {};


        if (!username.trim()) {

            newErrors.username = "Username is required";

        }


        if (!password.trim()) {

            newErrors.password = "Password is required";

        }


        setErrors(newErrors);


        if (Object.keys(newErrors).length > 0) {

            return;

        }


        await handleSendToSage(username, password);

    };
    //const handleSendToSage = (username, password) => {
    //    console.log("Sending to SAGE:", username, password);
    //    // your API logic here
    //};
    const handleSendToSage = async (username, password) => {

        if (selectedIds.length === 0) {

            alert("Please select at least one record before proceeding.");

            return;

        }

        if (selectedIds.length > 15) {

            alert("Please select a maximum of 15 records only.");

            return;

        }

        try {

            setSageSending(true);

            console.log("Sending to SAGE:", {

                invoiceIds: selectedIds,

                Username: username

            });

            await axios.post(

                "/api/invoices/send-to-sage",

                {

                    invoiceIds: selectedIds,

                    Username: username,

                    Password: password

                }

            );

            alert("Invoices sent to SAGE successfully");

            // Clear selected records

            setSelectedIds([]);

            // Close popup

            setShowModalNew(false);

            // Clear login fields

            setUsername("");

            setPassword("");

            setErrors({});

            // Refresh invoice list

            const res = await axios.get(

                "/api/invoices/cfo-list",

                {

                    params: {

                        statusId: selectedStatus,

                        search: searchTerm

                    }

                }

            );

            setInvoices(res.data || []);

            // Keep button disabled after successful send

            setSageSending(true);

        } catch (error) {

            console.error("SAGE ERROR:", error);

            alert(

                error?.response?.data?.message ||

                "Error sending to SAGE"

            );

            // Allow retry if sending failed

            setSageSending(false);

        }

    };

    const renderDocumentFile = (fileData, fileName, title) => {
        if (!fileData || typeof fileData !== "string" || fileData.trim() === "") {
            return <span style={{ color: "gray" }}>No file uploaded</span>;
        }

        let fileUrl = "";
        let cleanPath = fileData.trim();

        cleanPath = cleanPath.replace(/\\/g, "/");
        cleanPath = cleanPath.replace(/^~\/?/, "");
        cleanPath = cleanPath.replace(/^invoicecopy/i, "InvoiceCopy");

        if (cleanPath.startsWith("http")) {
            fileUrl = cleanPath;
        } else if (cleanPath.startsWith("JVBER")) {
            fileUrl = `data:application/pdf;base64,${cleanPath}`;
        } else {
            fileUrl = `${BASE_URL.replace(/\/$/, "")}/${cleanPath.replace(/^\/+/, "")}`;
        }

        const displayName =
            fileName ||
            (cleanPath.includes("/") ? cleanPath.split("/").pop() : "Document");

        return (
            <div style={{ display: "flex", flexDirection: "column" }}>
                <span style={{ color: "#0a4275", fontWeight: "500" }}>{displayName}</span>
                <div style={{ display: "flex", gap: "8px", marginTop: "5px" }}>
                    <Button
                        color="primary"
                        size="sm"
                        outline
                        onClick={() => {
                            window.open(fileUrl, "_blank");

                        }}
                    >
                        View
                    </Button>
                </div>
            </div>
        );
    };
    const previewOverlay = showPreview && (
        <div style={{
            position: "fixed",
            top: 0, left: 0,
            width: "100vw", height: "100vh",
            backgroundColor: "rgba(0,0,0,0.8)",
            zIndex: 9999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        }}>
            <div style={{ backgroundColor: "white", width: "90%", height: "90%", padding: "10px", display: "flex", flexDirection: "column" }}>
                <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "10px" }}>
                    <strong>{previewTitle}</strong>
                    <button onClick={() => setShowPreview(false)}>Close X</button>
                </div>
                {previewUrl && (
                    <iframe src={previewUrl} title="Preview" style={{ width: "100%", flex: 1, border: "none" }} />
                )}
            </div>
        </div>
    );
    return (
        <DashboardLayout>
            <div className="invoice-container">
                <h2 className="invoice-title" style={{ marginTop: 0, marginBottom: '2px', color: '#0a4275', paddingTop: '0px' }}>
                    Invoice Approval Details
                </h2>
                <div className="vendor-toolbar">
                    {/* Search Box */}
                    <div className="vendor-toolbar-search">
                        <div className="vendor-search-box invoice-search-box">
                            <span className="vendor-search-icon" aria-hidden="true">
                                <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <circle cx="11" cy="11" r="8" />
                                    <line x1="21" y1="21" x2="16.65" y2="16.65" />
                                </svg>
                            </span>
                            <Input
                                type="text"
                                placeholder="Search by Company Name..."
                                value={searchTerm}
                                onChange={(e) => {
                                    setSearchTerm(e.target.value);
                                    setCurrentPage(1);
                                }}
                                aria-label="Search by company name"
                                className="vendor-search-input"
                            />
                            {searchTerm && (
                                <button
                                    type="button"
                                    className="vendor-search-clear"
                                    aria-label="Clear search"
                                    onClick={() => { setSearchTerm(""); setCurrentPage(1); }}
                                >
                                    <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <line x1="6" y1="6" x2="18" y2="18" />
                                        <line x1="18" y1="6" x2="6" y2="18" />
                                    </svg>
                                </button>
                            )}
                        </div>
                    </div>
                    {isReadyToMoveSage && (
                        <Button
                            type="button"
                            color="success"
                            disabled={selectedIds.length === 0 || sageSending}
                            onClick={() => {
                                console.log("Send to SAGE clicked", selectedIds);
                                setShowModalNew(true);
                            }}
                            style={{
                                backgroundColor: "#1f4e78",
                                color: "white",
                                border: "none",
                                padding: "8px 18px",
                                borderRadius: "6px",
                                fontSize: "14px",
                                fontWeight: "500",
                                cursor: selectedIds.length === 0 || sageSending
                                    ? "not-allowed"
                                    : "pointer"
                            }}
                        >
                            {sageSending ? "Sending..." : "Send to SAGE"}
                        </Button>
                    )}

                    {showModalNew && (
                        <div style={styles.overlay}>
                            <div style={styles.modal}>
                                {/* Header */}
                                <div style={styles.header}>
                                    <h3 style={{ margin: 0 }}>SAGE Login</h3>
                                    <span style={styles.closeIcon} onClick={() => setShowModalNew(false)}>
                                        &times;
                                    </span>
                                </div>
                                {/* Body */}
                                <div style={styles.body}>
                                    <div style={styles.inputGroup}>
                                        <input
                                            type="text"
                                            placeholder="Username"
                                            value={username}
                                            onChange={(e) => setUsername(e.target.value)}
                                            style={styles.input}
                                        />
                                        {errors.username && (
                                            <div style={styles.error}>{errors.username}</div>
                                        )}
                                    </div>
                                    <div style={styles.inputGroup}>
                                        <input
                                            type="password"
                                            placeholder="Password"
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                            style={styles.input}
                                        />
                                        {errors.password && (
                                            <div style={styles.error}>{errors.password}</div>
                                        )}
                                    </div>
                                </div>
                                {/* Footer */}
                                <div style={styles.footer}>

                                    <button
                                        type="button"
                                        style={{
                                            ...styles.cancelBtn,
                                            cursor: "pointer"
                                        }}
                                        onClick={() => {
                                            setShowModalNew(false);
                                            setUsername("");
                                            setPassword("");
                                            setErrors({});
                                        }}
                                    >
                                        Cancel
                                    </button>

                                    <button
                                        type="button"
                                        style={{
                                            ...styles.submitBtn,
                                            opacity: sageSending ? 0.6 : 1,
                                            cursor: sageSending ? "not-allowed" : "pointer"
                                        }}
                                        onClick={handleSubmit}
                                        disabled={sageSending}
                                    >
                                        {sageSending ? "Sending..." : "Submit"}
                                    </button>

                                </div>
                            </div>
                        </div>
                    )}
                    {/* Status Dropdown */}
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                            flex: 1,
                            justifyContent: "flex-end", // 👈 pushes this to far right
                        }}
                    >
                        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                            <label style={{
                                fontWeight: "600",
                                color: "#0a4275",
                                fontSize: "14px"
                            }}>
                                Approved Status
                            </label>
                            <Input
                                type="select"
                                value={selectedStatus}
                                onChange={(e) => {
                                    setSelectedStatus(e.target.value);
                                    setCurrentPage(1);
                                }}
                                style={{
                                    width: "180px",
                                    borderRadius: "10px",
                                    height: "38px",
                                    padding: "5px 10px",
                                    fontSize: "14px",
                                    border: "1px solid #ced4da",
                                    boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                                    transition: "0.3s",
                                    cursor: "pointer",
                                    backgroundColor: "#f8fbff"
                                }}
                                onFocus={(e) => e.target.style.boxShadow = "0 0 6px rgba(10,66,117,0.4)"}
                                onBlur={(e) => e.target.style.boxShadow = "0 2px 6px rgba(0,0,0,0.1)"}
                            >
                                <option value={statusMapping.All}>📄 All Invoices</option>
                                <option value={statusMapping.Pending}>⏳ Pending</option>
                                <option value={statusMapping.Approved}>✅ Approved</option>
                                <option value={statusMapping.Rejected}>❌ Rejected</option>
                                <option value={statusMapping.ReadytoMoveSAGE}>🚀 Ready to Move SAGE</option>
                            </Input>
                        </div>
                    </div>
                </div>
                {/* Main Invoice Table */}
                <table className="invoice-table modern-table">
                    <thead>
                        <tr>
                            {isReadyToMoveSage && (
                                <th>
                                    <input
                                        type="checkbox"
                                        checked={currentInvoices.length > 0 && selectedIds.length === currentInvoices.length}
                                        onChange={(e) => {
                                            if (e.target.checked) {
                                                const allIds = currentInvoices.map(inv => inv.id);
                                                setSelectedIds(allIds.slice(0, 15));
                                            } else {
                                                setSelectedIds([]);
                                            }
                                        }}
                                    />                                    
                                </th>
                            )}
                            
                            <th className="company-name-header">Company Name</th>
                            <th>Invoice Type</th>
                            <th>Supplier Type</th>
                            <th>Invoice No</th>
                            <th>Total Value</th>
                            <th>DC Number</th>
                            <th>Create Date</th>
                            <th onClick={() => handleSort("approvalStatus")} style={{ cursor: "pointer" }}>
                                Approval Status {sortBy === "approvalStatus" ? (sortOrder === "asc" ? "▲" : "▼") : "⇅"}
                            </th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {currentInvoices.length === 0 ? (
                            <tr>
                                <td colSpan="10" className="no-data">
                                    No Invoices found
                                </td>
                            </tr>
                        ) : (
                                currentInvoices.map((invoice) => (
                                    <tr key={invoice.id}>
                                {isReadyToMoveSage && (
                                    <td>
                                        <input
                                            type="checkbox"
                                            checked={selectedIds.includes(invoice.id)}
                                            onChange={(e) => {
                                                let updatedIds;
                                                if (e.target.checked) {
                                                    if (selectedIds.length >= 15) {
                                                        alert("Please select a maximum of 15 records only.");
                                                        return;
                                                    }
                                                    updatedIds = [...selectedIds, invoice.id];
                                                } else {
                                                    updatedIds = selectedIds.filter(id => id !== invoice.id);
                                                }
                                                setSelectedIds(updatedIds);
                                            }}
                                        />
                                    </td>
                                )}
                                <td className="company-name-cell">
                                    {invoice.nameOfCompany || "N/A"}
                                </td>
                                <td>{invoice.invoiceType}</td>
                                <td>{invoice.supplierType}</td>
                                <td>{invoice.invoiceNo}</td>
                                <td>{invoice.totalValue.toLocaleString(undefined, { minimumFractionDigits: 2 })}</td>
                                <td>{invoice.dcnumber}</td>
                                <td>{invoice.createdDate}</td>
                                <td title={invoice.approvalStatus} className="approval-status-col">
                                    {invoice.approvalStatus}
                                </td>
                                <td>
                                            <button
                                                className="review-btn"
                                                onClick={() => handleReviewClick(invoice)}
                                            >
                                                Review
                                            </button>

                                </td>
                            </tr>
                        ))
                        )}
                    </tbody>
                </table>
                {/* Pagination */}
                <div className="pagination-modern">
                    <button
                        onClick={() => handlePageChange("first")}
                        disabled={currentPage === 1}
                    >
                        ⏮
                    </button>
                    <button
                        onClick={() => handlePageChange("prev")}
                        disabled={currentPage === 1}
                    >
                        ◀
                    </button>
                    <span className="page-info">
                        Page <strong>{currentPage}</strong> of <strong>{totalPages}</strong>
                    </span>
                    <button
                        onClick={() => handlePageChange("next")}
                        disabled={currentPage === totalPages}
                    >
                        ▶
                    </button>
                    <button
                        onClick={() => handlePageChange("last")}
                        disabled={currentPage === totalPages}
                    >
                        ⏭
                    </button>
                </div>
            </div>
            {/* ======================================================= */}
            {/* FULLSCREEN DIV — Invoice Info & Approve/Reject tabs      */}
            {/* ======================================================= */}
            {showModal && (activeTab === "details" || activeTab === "infoInvoice") && (
                <div style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100vw",
                    height: "100vh",
                    backgroundColor: "rgba(0,0,0,0.5)",
                    zIndex: 1055,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                }}>
                    <div style={{
                        backgroundColor: "white",
                        borderRadius: "8px",
                        width: "95%",
                        maxWidth: "1200px",
                        maxHeight: "90vh",
                        display: "flex",
                        flexDirection: "column",
                        overflow: "hidden",
                        boxShadow: "0 10px 40px rgba(0,0,0,0.3)"
                    }}>
                        {/* Header */}
                        <div style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "18px 24px",
                            flexShrink: 0,
                            background: "linear-gradient(135deg, #1f4e78, #2a5d8f)"
                        }}>
                            <h5 style={{ margin: 0, fontWeight: 600, color: "white", fontSize: "20px" }}>Invoice Details</h5>
                            <button
                                onClick={() => setShowModal(false)}
                                style={{
                                    background: "rgba(255,255,255,0.2)",
                                    border: "none",
                                    borderRadius: "50%",
                                    width: "32px",
                                    height: "32px",
                                    fontSize: "20px",
                                    cursor: "pointer",
                                    color: "white",
                                    lineHeight: 1,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center"
                                }}
                            >
                                &times;
                            </button>
                        </div>
                    {/* Tabs */}
                    <div style={{
                        display: "flex",
                        gap: "5px",
                        padding: "10px 24px 0",
                        borderBottom: "2px solid #1f4e78",
                        flexShrink: 0,
                        backgroundColor: "white"
                    }}>
                        {[
                            { key: "info", label: "Vendor Info" },
                            { key: "history", label: "Invoice Approval History" },
                            { key: "infoInvoice", label: "Invoice Info" },
                            { key: "details", label: "Approve/Reject" }
                        ].map((tab) => (
                            <span
                                key={tab.key}
                                onClick={() => setActiveTab(tab.key)}
                                style={{
                                    padding: "8px 16px",
                                    cursor: "pointer",
                                    borderRadius: "8px 8px 0 0",
                                    fontWeight: 500,
                                    fontSize: "14px",
                                    backgroundColor: activeTab === tab.key ? "#1f4e78" : "#f1f3f5",
                                    color: activeTab === tab.key ? "white" : "#333",
                                    userSelect: "none"
                                }}
                            >
                                {tab.label}
                            </span>
                        ))}
                    </div>
                    {/* Scrollable Body */}
                    <div style={{
                        flex: 1,
                        overflowY: "auto",
                        overflowX: "hidden",
                        padding: "20px 30px",
                        width: "100%",
                        boxSizing: "border-box"
                    }}>
                        {/* =================== APPROVE/REJECT TAB =================== */}
                        {activeTab === "details" && (
                            <>
                                <Table bordered className="info-table1">
                                    <tbody>
                                        <tr>
                                            <th>
                                                <strong>Approval Status:</strong>
                                                <span className="required-field">*</span>
                                            </th>
                                            <td>
                                                <Input
                                                    type="select"
                                                    value={selectedInvoice?.approvalStatus ?? ""}
                                                    disabled={isFinalStatus}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        setSelectedInvoice(prev => ({ ...(prev || {}), approvalStatus: value }));
                                                        setApprovalStatusError("");
                                                    }}
                                                >
                                                    <option value="">Select</option>
                                                    <option value="1">Approved</option>
                                                    <option value="2">Rejected</option>
                                                </Input>
                                                {!isFinalStatus && approvalStatusError && (
                                                    <div className="text-danger">{approvalStatusError}</div>
                                                )}
                                            </td>
                                            <th>
                                                <strong>Comments:</strong>
                                                <span className="required-field">*</span>
                                            </th>
                                            <td>
                                                <Input
                                                    type="textarea"
                                                    value={selectedInvoice?.comment ?? ""}
                                                    disabled={isFinalStatus}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        setSelectedInvoice(prev => ({ ...(prev || {}), comment: value }));
                                                        setCommentError("");
                                                    }}
                                                />
                                                {!isFinalStatus && commentError && (
                                                    <div className="text-danger">{commentError}</div>
                                                )}
                                            </td>
                                        </tr> 
                                        <tr>
                                            <th>
                                                <strong>Rejection Send To:</strong>
                                                <span className="required-field">*</span>
                                            </th>
                                            <td>
                                                <Input
                                                    type="select"
                                                    value={selectedInvoice?.rejectionSendTo || ""}
                                                    disabled={isFinalStatus || String(selectedInvoice?.approvalStatus) !== "2"}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        setSelectedInvoice(prev => ({ ...(prev || {}), rejectionSendTo: value }));
                                                        setRejectionSendToError("");
                                                    }}
                                                >
                                                    <option value="">Select</option>
                                                    <option value="1">Finance Team</option>
                                                    <option value="2">Dept Head</option>
                                                    <option value="3">PO</option>
                                                    <option value="4">Security</option>
                                                    <option value="5">Vendor</option>
                                                </Input>
                                                {rejectionSendToError && selectedInvoice?.approvalStatus === "2" && (
                                                    <div className="text-danger">{rejectionSendToError}</div>
                                                )}
                                            </td>
                                            <th></th>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <td colSpan={4}>
                                                <div className="text-center mt-3 mb-2">
                                                    <strong>The Following Goods have been Received</strong>
                                                </div>
                                                <div style={{ width: "100%", overflowX: "hidden" }}>
                                                    <table className="table table-bordered align-middle table-hover goods-table mt-2"
                                                        style={{ width: "100%", tableLayout: "fixed" }}>
                                                        <thead className="table-header11 text-center">
                                                            <tr>
                                                                <th style={{ width: "40px" }}>S. No.</th>
                                                                <th style={{ width: "160px" }}>Description</th>
                                                                <th style={{ width: "90px" }}>Invoice Value</th>
                                                                <th style={{ width: "120px" }}>Tax Group Code</th>
                                                                <th style={{ width: "80px" }}>CGST</th>
                                                                <th style={{ width: "80px" }}>SGST</th>
                                                                <th style={{ width: "80px" }}>IGST</th>
                                                                <th style={{ width: "80px" }}>TDS</th>
                                                                <th style={{ width: "90px" }}>Total Value</th>
                                                                <th style={{ width: "130px" }}>LOB</th>
                                                                <th style={{ width: "130px" }}>Project Name</th>
                                                                <th style={{ width: "70px" }}>MS/PS</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {(selectedInvoice?.goodsList || []).map((item, index) => {
                                                                const selectedGroup = taxGroupOptions.find(
                                                                    (group) => group.taxGroup?.toUpperCase() === item.taxGroupCode?.toUpperCase()
                                                                );
                                                                const authorities = selectedGroup?.authorities || [];
                                                                let cgstOptions = [];
                                                                let sgstOptions = [];
                                                                let igstOptions = [];
                                                                let tdsOptions = [];
                                                                authorities.forEach((auth) => {
                                                                    const authorityName = auth.taxAuthority?.toUpperCase() || "";
                                                                    const formattedRates = (auth.taxRates || [])
                                                                        .filter(rate => rate !== 0 && rate !== null && rate !== undefined)
                                                                        .map((rate, i) => ({
                                                                            itemRateKey: `itemRate${i + 1}`,
                                                                            label: `itemRate${i + 1} : ${Math.abs(rate)}%`,
                                                                            value: rate.toString()
                                                                        }));
                                                                    if (authorityName.includes("CGST")) cgstOptions.push(...formattedRates);
                                                                    if (authorityName.includes("SGST")) sgstOptions.push(...formattedRates);
                                                                    if (authorityName.includes("IGST")) igstOptions.push(...formattedRates);
                                                                    if (authorityName.includes("TDS")) tdsOptions.push(...formattedRates);
                                                                });
                                                                return (
                                                                    <tr key={index}>
                                                                        <td style={{ textAlign: "center" }}>{index + 1}</td>
                                                                        <td>{item.description || "N/A"}</td>
                                                                        <td>
                                                                            <Input type="text" value={item.invoiceValue || ""}
                                                                                disabled={isCFOView}
                                                                                onChange={(e) => handleGoodsChange(index, "invoiceValue", e.target.value)}
                                                                                style={{ width: "100%", fontSize: "12px", height: "28px" }} />
                                                                        </td>
                                                                        <td>
                                                                            <select className="form-select" value={item.taxGroupCode || ""}
                                                                                onChange={(e) => handleGoodsChange(index, "taxGroupCode", e.target.value)}
                                                                                style={{ width: "100%", fontSize: "12px", height: "28px" }}>
                                                                                <option value="">--Select--</option>
                                                                                {item.taxGroupCode && !taxGroupOptions.some(g => g.taxGroup?.toUpperCase() === item.taxGroupCode?.toUpperCase()) &&
                                                                                    <option value={item.taxGroupCode}>{item.taxGroupCode}</option>}
                                                                                {taxGroupOptions.map((group) => (
                                                                                    <option key={group.taxGroup} value={group.taxGroup}>
                                                                                        {group.taxGroup} - {group.description}
                                                                                    </option>
                                                                                ))}
                                                                            </select>
                                                                        </td>
                                                                        <td>
                                                                            <select className="form-select" value={item.cgst?.toString() || ""}
                                                                                onChange={(e) => handleGoodsChange(index, "cgst", e.target.value)}
                                                                                style={{ width: "100%", fontSize: "12px", height: "28px" }}>
                                                                                <option value="">--Select--</option>
                                                                                {cgstOptions.map((opt) => (
                                                                                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                                                                                ))}
                                                                            </select>
                                                                        </td>
                                                                        <td>
                                                                            <select className="form-select" value={item.sgst?.toString() || ""}
                                                                                onChange={(e) => handleGoodsChange(index, "sgst", e.target.value)}
                                                                                style={{ width: "100%", fontSize: "12px", height: "28px" }}>
                                                                                <option value="">--Select--</option>
                                                                                {sgstOptions.map((opt) => (
                                                                                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                                                                                ))}
                                                                            </select>
                                                                        </td>
                                                                        <td>
                                                                            <select className="form-select" value={item.igst?.toString() || ""}
                                                                                onChange={(e) => handleGoodsChange(index, "igst", e.target.value)}
                                                                                style={{ width: "100%", fontSize: "12px", height: "28px" }}>
                                                                                <option value="">--Select--</option>
                                                                                {igstOptions.map((opt) => (
                                                                                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                                                                                ))}
                                                                            </select>
                                                                        </td>
                                                                        <td>
                                                                            <select className="form-select" value={item.tds?.toString() || ""}
                                                                                onChange={(e) => handleGoodsChange(index, "tds", e.target.value)}
                                                                                style={{ width: "100%", fontSize: "12px", height: "28px" }}>
                                                                                <option value="">--Select--</option>
                                                                                {tdsOptions.map((opt) => (
                                                                                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                                                                                ))}
                                                                            </select>
                                                                        </td>
                                                                        <td>
                                                                            <Input type="text" value={item.totalValue || ""} readOnly
                                                                                style={{ width: "100%", fontSize: "12px", height: "28px" }} />
                                                                        </td>
                                                                        <td>
                                                                            <Input type="text" placeholder="Search LOB..."
                                                                                value={item.lobSearch || ""}
                                                                                onChange={(e) => handleGoodsChange(index, "lobSearch", e.target.value)}
                                                                                style={{ marginBottom: "4px", fontSize: "12px", height: "28px" }} />
                                                                            <select className="form-select" value={item.lob || ""}
                                                                                onChange={(e) => handleGoodsChange(index, "lob", e.target.value)}
                                                                                style={{ width: "100%", fontSize: "12px", height: "28px" }}>
                                                                                <option value="">--Select--</option>
                                                                                {item.lob && !lobOptions.includes(item.lob) &&
                                                                                    <option value={item.lob}>{item.lob}</option>}
                                                                                {lobOptions
                                                                                    .filter((lob) => lob.toLowerCase().includes((item.lobSearch || "").toLowerCase()))
                                                                                    .map((lob, i) => (
                                                                                        <option key={i} value={lob}>{lob}</option>
                                                                                    ))}
                                                                            </select>
                                                                        </td>
                                                                        <td>
                                                                            <Input type="text" placeholder="Search Project..."
                                                                                value={item.projectSearch || ""}
                                                                                onChange={(e) => handleGoodsChange(index, "projectSearch", e.target.value)}
                                                                                style={{ marginBottom: "4px", fontSize: "12px", height: "28px" }} />
                                                                            <select className="form-select" value={item.projectName || ""}
                                                                                onChange={(e) => handleGoodsChange(index, "projectName", e.target.value)}
                                                                                style={{ width: "100%", fontSize: "12px", height: "28px" }}>
                                                                                <option value="">--Select--</option>
                                                                                {item.projectName && !projectNameOptions.some(p => (p?.value || p) === item.projectName) &&
                                                                                    <option value={item.projectName}>{item.projectName}</option>}
                                                                                {projectNameOptions
                                                                                    .filter((proj) =>
                                                                                        (proj?.value || proj?.toString() || "")
                                                                                            .toLowerCase()
                                                                                            .includes((item.projectSearch || "").toLowerCase())
                                                                                    )
                                                                                    .map((proj, i) => (
                                                                                        <option key={i} value={proj.value || proj}>{proj.value || proj}</option>
                                                                                    ))}
                                                                            </select>
                                                                        </td>
                                                                        <td>
                                                                            <select className="form-select" value={item.mspe || ""}
                                                                                onChange={(e) => handleGoodsChange(index, "mspe", e.target.value)}
                                                                                style={{ width: "100%", fontSize: "12px", height: "28px" }}>
                                                                                <option value="">--Select--</option>
                                                                                <option value="MS">MS</option>
                                                                                <option value="PS">PS</option>
                                                                                <option value="NA">NA</option>
                                                                            </select>
                                                                        </td>
                                                                    </tr>
                                                                );
                                                            })}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </>
                        )}
                        {/* =================== INVOICE INFO TAB =================== */}
                        {activeTab === "infoInvoice" && invoiceInfo && (
                            <>
                                <Table bordered className="info-table1">
                                    <tbody>
                                        <tr>
                                            <th><strong>Invoice Type:</strong></th>
                                            <td>{invoiceInfo.invoiceType || "N/A"}</td>
                                            <th><strong>Supplier Type:</strong></th>
                                            <td>
                                                {invoiceInfo.invoiceSupplierType === 1 ? "Supply of Goods"
                                                    : invoiceInfo.invoiceSupplierType === 2 ? "Supply of Service" : "N/A"}
                                            </td>
                                        </tr>
                                        <tr>
                                            <th><strong>Invoice Document:</strong></th>
                                            <td>{renderDocumentFile(invoiceInfo.invoiceFilePath, invoiceInfo.fileName, "Invoice Document Preview")}</td>
                                            <th><strong>Invoice Date:</strong></th>
                                            <td>{invoiceInfo.invoiceDate ? new Date(invoiceInfo.invoiceDate).toLocaleDateString("en-GB") : "N/A"}</td>
                                        </tr>
                                        <tr>
                                            <th><strong>Invoice No:</strong></th>
                                            <td>{invoiceInfo.invoiceNo || "N/A"}</td>
                                            <th><strong>PO No:</strong></th>
                                            <td>{invoiceInfo.pono || "N/A"}</td>
                                        </tr>
                                        <tr>
                                            <th><strong>Delivery Challan No:</strong></th>
                                            <td>{invoiceInfo.deliveryChallanNumber || "N/A"}</td>
                                            <th><strong>Invoice Value:</strong></th>
                                            <td>{invoiceInfo.invoiceValue?.toFixed(2) || "0.00"}</td>
                                        </tr>
                                        <tr>
                                            <th><strong>IGST:</strong></th>
                                            <td>{invoiceInfo.igst?.toFixed(2) || "0.00"}</td>
                                            <th><strong>CGST:</strong></th>
                                            <td>{invoiceInfo.cgst?.toFixed(2) || "0.00"}</td>
                                        </tr>
                                        <tr>
                                            <th><strong>SGST:</strong></th>
                                            <td>{invoiceInfo.sgst?.toFixed(2) || "0.00"}</td>
                                            <th><strong>Total Value:</strong></th>
                                            <td>{invoiceInfo.totalValue?.toFixed(2) || "0.00"}</td>
                                        </tr>
                                        <tr>
                                            <th><strong>Created Date:</strong></th>
                                            <td>{invoiceInfo.createdDate ? new Date(invoiceInfo.createdDate).toLocaleDateString("en-GB") : "N/A"}</td>
                                            <th><strong>Agreement Document:</strong></th>
                                            <td>{renderDocumentFile(invoiceInfo.agreementFilePath, invoiceInfo.fileNameAgreement, "Agreement Document Preview")}</td>
                                        </tr>
                                        <tr>
                                            <th><strong>Email Approval:</strong></th>
                                            <td>{renderDocumentFile(invoiceInfo.poDocuments?.emailApprovalFilePath, "Email Approval", "Email Approval Preview")}</td>
                                            <th><strong>Invoice (PO Upload):</strong></th>
                                            <td>{renderDocumentFile(invoiceInfo.poDocuments?.invoiceIMAGEFilePath, "Invoice Document", "Invoice Preview")}</td>
                                        </tr>
                                        <tr>
                                            <th><strong>PO Attachment:</strong></th>
                                            <td>{renderDocumentFile(invoiceInfo.poDocuments?.poimageFilePath, "PO Document", "PO Preview")}</td>
                                            <th><strong>PR Attachment:</strong></th>
                                            <td>{renderDocumentFile(invoiceInfo.poDocuments?.primageFilePath, "PR Document", "PR Preview")}</td>
                                        </tr>
                                        <tr>
                                            <th><strong>Quotation:</strong></th>
                                            <td>{renderDocumentFile(invoiceInfo.poDocuments?.quotationIMAGEFilePath, "Quotation 1", "Quotation Preview")}</td>
                                            <th><strong>More Quotation:</strong></th>
                                            <td>{renderDocumentFile(invoiceInfo.poDocuments?.quotation2IMAGEFilePath, "Quotation 2", "Quotation Preview")}</td>
                                        </tr>
                                        <tr>
                                            <th><strong>Comparison Quotes:</strong></th>
                                            <td>{renderDocumentFile(invoiceInfo.poDocuments?.comparisonquotesFilePath, "Comparison Quotes", "Comparison Preview")}</td>
                                            <th><strong>Evaluation Form:</strong></th>
                                            <td>{invoiceInfo.evaluationForm ? <a href={invoiceInfo.evaluationForm} target="_blank" rel="noopener noreferrer">View</a> : "N/A"}</td>
                                        </tr>
                                        <tr>
                                            <th><strong>Other Documents:</strong></th>
                                            <td>{renderDocumentFile(invoiceInfo.poDocuments?.otherDocuementsIMAGEFilePath, "Other Documents", "Other Documents Preview")}</td>
                                            <th><strong>TimeSheet:</strong></th>
                                            <td>{renderDocumentFile(invoiceInfo.timeSheetFilePath, invoiceInfo.fileNameTimeSheet, "TimeSheet Preview")}</td>
                                        </tr>
                                        <tr>
                                            <th><strong>GRN Attachment:</strong></th>
                                            <td>{invoiceInfo.grnAttachment ? <a href={invoiceInfo.grnAttachment} target="_blank" rel="noopener noreferrer">View</a> : "N/A"}</td>
                                            <th><strong>Quotation 3:</strong></th>
                                            <td>{renderDocumentFile(invoiceInfo.poDocuments?.quotation3IMAGEFilePath, "Quotation 3", "Quotation 3 Preview")}</td>
                                        </tr>
                                    </tbody>
                                </Table>
                                <h5 className="text-primary fw-bold mb-3">The Following goods has been Received.</h5>
                                <table className="table table-bordered align-middle table-hover invoice-table">
                                    <thead className="table-header11 text-center">
                                        <tr>
                                            <th>Sr. No</th>
                                            <th>Description</th>
                                            <th>Ordered Qty</th>
                                            <th>Supplied Qty</th>
                                            <th>Invoice Value</th>
                                            <th>CGST (%)</th>
                                            <th>SGST (%)</th>
                                            <th>IGST (%)</th>
                                            <th>Total Value</th>
                                            <th>Remarks</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {invoiceInfo?.grnItems?.length > 0 ? (
                                            invoiceInfo.grnItems.map((item, index) => (
                                                <tr key={item.id} className="text-center">
                                                    <td>{index + 1}</td>
                                                    <td className="text-start">{item.description || "-"}</td>
                                                    <td>{item.qty ?? 0}</td>
                                                    <td>{item.rcvQty ?? 0}</td>
                                                    <td>{item.invoiceValue?.toFixed(2) ?? "0.00"}</td>
                                                    <td>{item.cgst ?? 0}</td>
                                                    <td>{item.sgst ?? 0}</td>
                                                    <td>{item.igst ?? 0}</td>
                                                    <td>{item.totalValue?.toFixed(2) ?? "0.00"}</td>
                                                    <td>{item.remark || "-"}</td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="10" style={{ textAlign: "center" }}>No GRN Items Available</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </>
                        )}
                    </div>
                    {/* Footer — only for Approve/Reject tab */}
                    {activeTab === "details" && (
                        <div style={{
                            padding: "12px 24px",
                            borderTop: "1px solid #dee2e6",
                            display: "flex",
                            gap: "10px",
                            justifyContent: "flex-end",
                            flexShrink: 0,
                            backgroundColor: "white"
                        }}>
                            {!isFinalStatus && (
                                <Button color="success" onClick={handleSaveStatus}>Save</Button>
                            )}
                            <Button color="danger" onClick={() => setShowModal(false)}>Close</Button>
                        </div>
                        )}
                        {previewOverlay}  
                    
                    </div>
                </div>
            )}
            {/* ======================================================= */}
            {/* REACTSTRAP MODAL — Vendor Info & History tabs only       */}
            {/* ======================================================= */}
            {showModal && (activeTab === "info" || activeTab === "history") && (
                <div style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100vw",
                    height: "100vh",
                    backgroundColor: "rgba(0,0,0,0.5)",
                    zIndex: 1055,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                }}>
                    <div style={{
                        backgroundColor: "white",
                        borderRadius: "8px",
                        width: "95%",
                        maxWidth: "1200px",
                        maxHeight: "90vh",
                        display: "flex",
                        flexDirection: "column",
                        overflow: "hidden",
                        boxShadow: "0 10px 40px rgba(0,0,0,0.3)"
                    }}>
                        {/* Header */}
                        <div style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "18px 24px",
                            flexShrink: 0,
                            background: "linear-gradient(135deg, #1f4e78, #2a5d8f)"
                        }}>
                            <h5 style={{ margin: 0, fontWeight: 600, color: "white", fontSize: "20px" }}>Invoice Details</h5>
                            <button
                                onClick={() => setShowModal(false)}
                                style={{
                                    background: "rgba(255,255,255,0.2)",
                                    border: "none",
                                    borderRadius: "50%",
                                    width: "32px",
                                    height: "32px",
                                    fontSize: "20px",
                                    cursor: "pointer",
                                    color: "white",
                                    lineHeight: 1,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center"
                                }}
                            >
                                &times;
                            </button>
                        </div>

                        {/* Tabs — identical style to the other modal */}
                        <div style={{
                            display: "flex",
                            gap: "5px",
                            padding: "10px 24px 0",
                            borderBottom: "2px solid #1f4e78",
                            flexShrink: 0,
                            backgroundColor: "white"
                        }}>
                            {[
                                { key: "info", label: "Vendor Info" },
                                { key: "history", label: "Invoice Approval History" },
                                { key: "infoInvoice", label: "Invoice Info" },
                                { key: "details", label: "Approve/Reject" }
                            ].map((tab) => (
                                <span
                                    key={tab.key}
                                    onClick={() => setActiveTab(tab.key)}
                                    style={{
                                        padding: "8px 16px",
                                        cursor: "pointer",
                                        borderRadius: "8px 8px 0 0",
                                        fontWeight: 500,
                                        fontSize: "14px",
                                        backgroundColor: activeTab === tab.key ? "#1f4e78" : "#f1f3f5",
                                        color: activeTab === tab.key ? "white" : "#333",
                                        userSelect: "none"
                                    }}
                                >
                                    {tab.label}
                                </span>
                            ))}
                        </div>

                        {/* Scrollable Body */}
                        <div style={{
                            flex: 1,
                            overflowY: "auto",
                            overflowX: "hidden",
                            padding: "20px 30px",
                            width: "100%",
                            boxSizing: "border-box"
                        }}>
                            {activeTab === "info" && (
                                selectedVendor ? (
                                    <VendorInfoTabs
                                        selectedVendor={selectedVendor}
                                        vendorFiles={files}
                                        isEditing={isEditing}
                                        setIsEditing={setIsEditing}
                                        handleInputChange={(e, field) =>
                                            setSelectedVendor({ ...selectedVendor, [field]: e.target.value })
                                        }
                                        subTab={subTab}
                                        setSubTab={setSubTab}
                                        type="invoice"
                                    />
                                ) : (
                                    <div style={{ textAlign: "center", padding: "60px 20px", color: "#888", fontSize: "15px" }}>
                                        No vendor information available for this invoice.
                                    </div>
                                )
                            )}

                            {activeTab === "history" && (
                                <div className="history-container1">
                                    <table className="table table-bordered align-middle table-hover invoice-table">
                                        <thead className="table-header11 text-center">
                                            <tr>
                                                <th>#</th>
                                                <th>Approval Status</th>
                                                <th>Approver Name</th>
                                                <th>Date</th>
                                                <th>Comments</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {historyData.length > 0 ? (
                                                historyData.map((item, index) => (
                                                    <tr key={index}>
                                                        <td>{index + 1}</td>
                                                        <td>{item.approvalStatus || "N/A"}</td>
                                                        <td>{item.approvalname || "N/A"}</td>
                                                        <td>{item.createdate ? new Date(item.createdate).toLocaleDateString("en-GB") : "N/A"}</td>
                                                        <td>{item.comments || "N/A"}</td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="5" className="text-center">No history found</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Preview Modal — unchanged, still reactstrap */}
                    <Modal isOpen={showPreview} toggle={() => setShowPreview(false)} size="lg" centered>
                        <ModalHeader toggle={() => setShowPreview(false)}>{previewTitle}</ModalHeader>
                        <ModalBody style={{ padding: 0 }}>
                            {previewUrl ? (
                                <iframe src={previewUrl} title="Preview" style={{ width: "100%", height: "80vh", border: "none" }} />
                            ) : (
                                <p style={{ padding: "20px" }}>No preview available</p>
                            )}
                        </ModalBody>
                    </Modal>
                    {previewOverlay}
                </div>
            )}        </DashboardLayout>
    );
};
export default ViewAllInvoicesCFO;